import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { bindActionCreators } from 'redux'
import * as lmexpressActions from 'action/lmexpress'
import Form from 'component/lmexpress/EditForm'
import ContentHeader from 'component/utils/ContentHeader'
import Notification from 'component/utils/Notification'
import Breadcrumb from 'component/Breadcrumb'

class LmExpressParametersContainer extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    records: PropTypes.object.isRequired,
    isUpdating: PropTypes.bool.isRequired,
    updated: PropTypes.bool.isRequired,
    error: PropTypes.object,
    fetchLmExpressParameters: PropTypes.func.isRequired,
    updateLmExpressParameters: PropTypes.func.isRequired,
  }

  componentDidMount() {
    const { fetchLmExpressParameters, auth } = this.props

    fetchLmExpressParameters(auth)
  }

  handleSubmit = (params) => {
    const { updateLmExpressParameters, auth } = this.props

    updateLmExpressParameters(auth, params)
  }

  renderUpdateNotification = () => {
    const { translate } = this.props

    return (
      <Notification
        className='notification-success margin-top'
        message={translate('lmexpress.parameter.update-success')}
      />
    )
  }

  renderUpdateErrorNotification = () => {
    const { translate } = this.props

    return (
      <Notification
        className='notification-success margin-top'
        message={translate('lmexpress.parameter.update-fail')}
      />
    )
  }

  renderBreadcrumb = () => {
    const { translate } = this.props

    const steps = [
      { link: '/', title: translate('mobile.home') },
      { title: translate('lmexpress.parameters.title') },
    ]

    return <Breadcrumb steps={steps} />
  }

  render() {
    const { auth, translate, updated, error, records } = this.props

    return (
      <section>
        <ContentHeader>{translate('lmexpress.parameters.title')}</ContentHeader>

        {this.renderBreadcrumb()}

        {updated && this.renderUpdateNotification()}
        {error && this.renderUpdateErrorNotification()}

        <div className='padding'>
          {records && records.inLotOrHue !== undefined && (
            <Form
              translate={translate}
              onSubmit={this.handleSubmit}
              records={records}
              auth={auth}
            />
          )}
        </div>
      </section>
    )
  }
}

/*
 * Maps redux state to component props
 */
const mapStateToProps = ({ lmExpressReducer }) => ({
  records: lmExpressReducer.parameters.records,
  isUpdating: lmExpressReducer.edit.isUpdating,
  updated: lmExpressReducer.edit.updated,
  error: lmExpressReducer.edit.error,
})

/*
 * Maps actions and dispatch them to component props
 */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(lmexpressActions, dispatch)

/*
 * Connects component to I18next
 */
const LmExpressParametersTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(LmExpressParametersContainer)

/*
 * Exports component connected to redux as default
 */
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LmExpressParametersTranslated)

/*
 * Exports as component
 */
export { LmExpressParametersContainer as Home }
